import { makeStyles } from '@mui/styles';

export const useCarrierDetailsPageHeaderStyles = makeStyles((theme) => ({
  root: {
    padding: '3rem 0',
    color: '#ffffff',
    position: 'relative',
    minHeight: '212px'
  },
  // The badge sits beside the name on desktop, and stacks under it once there is no room.
  carrierName: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem',
    // The reboot gives headings a bottom margin and no top one, and flex centres the margin box —
    // so without this the name sits high against the badge.
    '& h2': {
      margin: 0
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '0.5rem'
    }
  },
  subtitle: {
    color: '#ffffffc4',
    fontSize: '1rem',
    minHeight: '1.85rem',
    // Puts back the space the heading's own bottom margin used to give it.
    paddingTop: '0.5rem',
    marginBottom: '5px'
  },
  subtitleSeparator: {
    margin: '0 0.5rem',
    opacity: 0.6
  },
  // Every state names its own colour: the global `a:hover` reboot wins over anything inherited.
  subtitleLink: {
    color: '#ffffff',
    textDecoration: 'underline',
    '&:hover, &:focus': {
      color: '#ffffffc4'
    }
  },
  // Aspect ratios vary wildly, so cap the height and let the width follow. Dropped on mobile.
  carrierImage: {
    maxHeight: '48px',
    maxWidth: '100%',
    objectFit: 'contain',
    marginTop: '0.5rem',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  info: {
    fontSize: '14px',
    marginBottom: '1rem'
  },
  capabilities: {
    textTransform: 'uppercase',
    color: '#ffffffc4',
    fontSize: '14px'
  },
  capabilitiesIcon: {
    height: 24,
    width: 24
  },
  actionButtonBox: {
    position: 'absolute',
    top: '3rem',
    right: 0
  }
}));
